export default __webpack_public_path__ + "images/dbd52904dfa5c6385cd1f5d4f3428058.svg";